import { SxProps, Theme } from '@mui/system';
import ThemeConstants from '../../../theme/ThemeConstants';

const styles = {
  container: {
    width: '100%',
    maxWidth: 700,
  },
  labelContainer: {
    display: 'flex',
    flex: 1,
  },
  label: {
    ml: '12px',
    fontSize: '18px',
    color: 'grey.800',
  },
  viewButton: {
    '&.MuiButton-root': {
      backgroundColor: ThemeConstants.common.counterRed,
      color: ThemeConstants.secondary.main,
    },
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
